import { render } from "./RepresentativePin.vue?vue&type=template&id=39d38302&ts=true"
import script from "./RepresentativePin.vue?vue&type=script&lang=ts"
export * from "./RepresentativePin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__